import { 
  useIsGameStarted,
  usePlayerSeat as useGamePlayerSeat,
  useIsWaitingForBigBlind,
  useSitOutOption,
  useIsTourneyGame
} from '@/src/hooks/data/useGameTable';
import React from 'react'
import styles from './PlayNext.module.css'
import { doesExist } from '@/Common/utils/GameUtils';
import { FaCheck } from 'react-icons/fa';
import { AnimatePresence, LayoutGroup, motion } from 'motion/react';
import useGameSocket from '@/src/hooks/utils/useGameSocket';

export default function PlayNext({ tempTableId, atTableAmount, isActive }) {
    const isGameStarted = useIsGameStarted(tempTableId);
    const playerSeat = useGamePlayerSeat(tempTableId);
    const isWaitingForBigBlind = useIsWaitingForBigBlind(tempTableId);
    const sitOutOption = useSitOutOption(tempTableId);
    const isTourneyGame = useIsTourneyGame(tempTableId);
    const { sendPlayNextRequest } = useGameSocket(tempTableId);

    const showPlayNext = isGameStarted && doesExist(playerSeat) && atTableAmount > 0 && !sitOutOption && !isActive && !isTourneyGame;

    if (!showPlayNext) return null;

    const playNextActive = isWaitingForBigBlind === false;

    return (
        <div onClick={() => sendPlayNextRequest(isWaitingForBigBlind)} className={styles.playNextContainer}>
            <motion.div layout={true} className={`${styles.playNextButton} ${playNextActive ? styles.activePlayNextButton : ''}`}>
                <LayoutGroup>
                    <AnimatePresence>
                        {
                            playNextActive ? (
                                <motion.div
                                    layout={true}
                                    initial={{ opacity: 0, scale: 0 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    exit={{ opacity: 0, scale: 0 }}
                                    transition={{ duration: 0.2 }}
                                >
                                    <FaCheck
                                        style={{
                                            filter: 'drop-shadow(0 0px 5px var(--color-accent-theme))'
                                        }}
                                        size={12} color={'var(--color-focus)'} />
                                </motion.div>
                            ) : null
                        }
                    </AnimatePresence>
                    <motion.div layout={true} className={styles.playNextLabel}>Play next</motion.div>
                </LayoutGroup>
            </motion.div>
        </div>
    )
}
